module.exports = {
        srcSet: __webpack_public_path__ + "static/media/inboxWithArrow-500.4804dd54.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/inboxWithArrow-500.4804dd54.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/inboxWithArrow-500.4804dd54.webp",
        toString: function(){return __webpack_public_path__ + "static/media/inboxWithArrow-500.4804dd54.webp"},
        
        width: 500,
        height: 500
      }